module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fb-Gb-Hc 后背.1faf70ea.png";